var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _vm.canEditRoles()
              ? _c(
                  "b-btn",
                  {
                    staticClass: "custom-btn-primary",
                    attrs: { disabled: _vm.isBusy },
                    on: {
                      click: function($event) {
                        return _vm.showModal(null, false)
                      }
                    }
                  },
                  [
                    _vm.isBusy
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                    _vm._v("\n        Новая роль\n      ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "div",
            { staticClass: "page-filters" },
            [
              _c("filters-drawer", {
                attrs: { query: _vm.filters.query, "is-busy": _vm.isBusy },
                on: {
                  "update:query": function($event) {
                    return _vm.$set(_vm.filters, "query", $event)
                  },
                  submit: _vm.onSearch
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy || (_vm.items && _vm.items.length > 0)
            ? [
                _c(
                  "div",
                  { staticClass: "page-table-container" },
                  [
                    _c("b-table", {
                      ref: "user_roles",
                      staticClass: "custom-table mb-0 text-small",
                      attrs: {
                        id: "user-roles",
                        "sticky-header": "",
                        selectable: "",
                        "select-mode": "single",
                        responsive: "",
                        busy: _vm.isBusy,
                        items: _vm.items,
                        fields: _vm.fields,
                        "no-provider-filtering": "",
                        "no-provider-paging": "",
                        "no-provider-sorting": "",
                        "no-local-sorting": ""
                      },
                      on: {
                        "update:busy": function($event) {
                          _vm.isBusy = $event
                        },
                        "sort-changed": _vm.sortChanged,
                        "row-dblclicked": _vm.onRowClicked
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c("tables-skeleton", {
                                  attrs: { fields: _vm.fields, rows: 4 }
                                })
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(active)",
                            fn: function(row) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center align-items-center"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ant-switch-wrapper",
                                        attrs: {
                                          title: row.item.active
                                            ? "Отключить роль"
                                            : "Включить роль"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      },
                                      [
                                        _c("b-form-checkbox", {
                                          staticClass: "m-0",
                                          attrs: {
                                            checked: row.item.active,
                                            disabled:
                                              !_vm.canEditRoles() ||
                                              _vm.isRoleUpdating(row.item.id),
                                            "aria-label": row.item.active
                                              ? "Отключить роль"
                                              : "Включить роль",
                                            switch: ""
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.onActiveChange(
                                                row.item,
                                                $event
                                              )
                                            }
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "switch-icons-overlay"
                                          },
                                          [
                                            _c("v-icon", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: row.item.active,
                                                  expression: "row.item.active"
                                                }
                                              ],
                                              staticClass: "ml-2",
                                              staticStyle: { color: "#fff" },
                                              attrs: {
                                                name: "buttons/check",
                                                size: 11
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !row.item.active,
                                                  expression: "!row.item.active"
                                                }
                                              ],
                                              staticClass: "flex-grow-1"
                                            }),
                                            _vm._v(" "),
                                            _c("v-icon", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !row.item.active,
                                                  expression: "!row.item.active"
                                                }
                                              ],
                                              staticClass: "mr-2",
                                              staticStyle: { color: "#fff" },
                                              attrs: {
                                                name: "buttons/cross",
                                                size: 10
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "custom-dropdown",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class":
                                        "text-decoration-none box-shadow-none",
                                      "no-caret": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function() {
                                            return [
                                              _c("v-icon", {
                                                attrs: {
                                                  name:
                                                    "buttons/ellipsis_vertical",
                                                  size: 15
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: { variant: "success" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showModal(
                                              row.item.id,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            name: "buttons/eye",
                                            size: 14
                                          }
                                        }),
                                        _vm._v(
                                          "\n                Смотреть\n              "
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.canEditRoles()
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function($event) {
                                                return _vm.showModal(
                                                  row.item.id,
                                                  false
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                name: "buttons/edit",
                                                size: 14
                                              }
                                            }),
                                            _vm._v(
                                              "\n                Редактировать\n              "
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.canEditRoles()
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: { variant: "danger" },
                                            on: {
                                              click: function($event) {
                                                return _vm.onRemove(row)
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                name: "buttons/trash",
                                                size: 14
                                              }
                                            }),
                                            _vm._v(
                                              "\n                Удалить\n              "
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        867538412
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-pagination" },
                  [
                    _c("pagination-footer", {
                      attrs: {
                        "use-router": "",
                        "current-page": _vm.currentPage,
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:perPage": function($event) {
                          _vm.perPage = $event
                        },
                        "update:per-page": function($event) {
                          _vm.perPage = $event
                        },
                        "page-click": _vm.onPagination,
                        "per-page-change": _vm.onPerPageChange
                      }
                    })
                  ],
                  1
                )
              ]
            : _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.isFiltered
                          ? "Нет данных соответствующих фильтрам."
                          : "Нет созданных ролей."
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isFiltered
                    ? _c(
                        "div",
                        [
                          _c("p", [_vm._v("Создайте новую роль прямо сейчас")]),
                          _vm._v(" "),
                          _vm.canEditRoles()
                            ? _c(
                                "b-btn",
                                {
                                  staticClass: "custom-btn-primary mt-1",
                                  attrs: { disabled: _vm.isBusy },
                                  on: {
                                    click: function($event) {
                                      return _vm.showModal(null, false)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", {
                                    staticClass: "mr-1",
                                    attrs: { name: "buttons/plus", size: 12 }
                                  }),
                                  _vm._v("\n          Новая роль\n        ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _c("UserRole", {
        ref: "user_role",
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18270ecb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18270ecb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserRoles.vue
// module id = null
// module chunks = 